
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class DepartmentMasterDialog extends Serenity.EntityDialog<DepartmentMasterRow, any> {
        protected getFormKey() { return DepartmentMasterForm.formKey; }
        protected getIdProperty() { return DepartmentMasterRow.idProperty; }
        protected getLocalTextPrefix() { return DepartmentMasterRow.localTextPrefix; }
        protected getNameProperty() { return DepartmentMasterRow.nameProperty; }
        protected getService() { return DepartmentMasterService.baseUrl; }
        protected getDeletePermission() { return DepartmentMasterRow.deletePermission; }
        protected getInsertPermission() { return DepartmentMasterRow.insertPermission; }
        protected getUpdatePermission() { return DepartmentMasterRow.updatePermission; }

        protected form = new DepartmentMasterForm(this.idPrefix);

        constructor() {
            super();
            this.form.DepartmentTypeId.changeSelect2(e => {
                if (this.form.DepartmentTypeId.value == "142" || this.form.DepartmentTypeId.value == "143") {
                    q.showAndSetRequiredField(this.form.ProcessDetails);

                } else {
                    q.hideField(this.form.ProcessDetails);
                }
            });
        }
        onDialogOpen() {
            super.onDialogOpen();
            if (this.form.DepartmentTypeId.value == "142" || this.form.DepartmentTypeId.value == "143") {
                q.showAndSetRequiredField(this.form.ProcessDetails);

            } else {
                q.hideField(this.form.ProcessDetails);
            }
        }
    }
}